import React from 'react';
import { FaChartLine, FaLock, FaTools, FaUserCheck } from 'react-icons/fa';

const Features = () => {
    const features = [
        {
            icon: <FaChartLine />,
            title: 'Financial Insights',
            description: 'Track income, budgets, and spending trends with easy-to-read dashboards and downloadable reports.',
        },
        {
            icon: <FaUserCheck />,
            title: 'Resident Management',
            description: 'Quickly view homeowner info, payment history, and communication logs from one centralized location.',
        },
        {
            icon: <FaLock />,
            title: 'Encryption',
            description: 'Bank account and credit card details encrypted, showing only the last four digits.',
        },
        {
            icon: <FaTools />,
            title: 'Maintenance Tasks',
            description: 'Assign, track, and resolve maintenance issues efficiently with built-in task workflows.',
        },
    ];

    return (
        <section
            id="features"
            className="py-16 px-4 md:py-20 md:px-8 text-center bg-gradient-to-b from-gray-50 to-white"
        >
            <h2 className="text-2xl md:text-4xl mb-8 font-bold bg-gradient-to-r from-[#2731a3] to-[#1a2280] bg-clip-text text-transparent">
                Powerful Features for Modern HOAs
            </h2>
            <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mt-8">
                {features.map((feature, index) => (
                    <div
                        className="p-8 border border-blue-700/20 rounded-lg transition-all duration-300 ease-in-out bg-white shadow-md hover:-translate-y-2 hover:shadow-xl hover:border-blue-700/40 group"
                        key={index}
                    >
                        <div className="flex justify-center items-center text-4xl text-[#2731a3] mb-4 group-hover:text-[#1a2280] transition-colors duration-300">
                            {feature.icon}
                        </div>
                        <h2 className="text-xl font-semibold text-[#2731a3] mb-2">
                            {feature.title}
                        </h2>
                        <p className="text-gray-600">{feature.description}</p>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default Features;